import { render, staticRenderFns } from "./galleryDetail.vue?vue&type=template&id=09ec2fe6&scoped=true"
import script from "./galleryDetail.vue?vue&type=script&lang=js"
export * from "./galleryDetail.vue?vue&type=script&lang=js"
import style0 from "./galleryDetail.vue?vue&type=style&index=0&id=09ec2fe6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ec2fe6",
  null
  
)

export default component.exports